/* src/app/components/to-order-button/to-order-button.component.scss */
.add-to-order-button {
  margin: 12px;
}
ion-button {
  width: 100%;
}
.vertical-line {
  height: 55%;
  width: 0.6px;
  margin-inline: 10px;
  background-color: #fff;
}
.quantity {
  width: 25px;
  height: 25px;
  border: 1px solid var(--color-black);
  border-radius: 50%;
  background: var(--color-background-alt);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  color: var(--color-black);
}
/*# sourceMappingURL=to-order-button.component.css.map */
